import { api } from '../lib/api'
import type { Role, User } from '../lib/types'

export interface CreateUserInput {
  name: string
  email: string
  password: string
  role: Role
  active?: boolean
}

export interface UpdateUserInput {
  name?: string
  email?: string
  role?: Role
  active?: boolean
}

export const usersApi = {
  list: () => api.get<{ users: User[] }>('/users'),
  create: (data: CreateUserInput) => api.post<{ user: User }>('/users', data),
  update: (id: string, data: UpdateUserInput) => api.put<{ user: User }>(`/users/${id}`, data),
  resetPassword: (id: string, password: string) =>
    api.post<{ ok: true }>(`/users/${id}/reset-password`, { password }),
  remove: (id: string) => api.del<{ ok: true }>(`/users/${id}`),
  changeOwnPassword: (currentPassword: string, newPassword: string) =>
    api.put<{ ok: true }>('/users/me/password', { currentPassword, newPassword }),
}
